/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 500 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: false // Set to false to use static SVG
};

const greeting = {
  username: "Selina Wan",
  title: "Hii, I'm Selina",
  subTitle: "I am a graduate student in robotics and machine learning, currently pursuing my Master’s degree in Robotics at the University of Pennsylvania, with an anticipated graduation in June 2026. My academic and professional journey has span across self-driving cars, robotics, computer vision, deep learning, and software engineering. With a strong foundation in research and hands-on experience, I am eager to continue pushing the boundaries of these fields. I am currently looking for a new graduate role as a Robotics Software Engineer or Machine Learning Engineer."
  ,
  resumeLink:
    "https://drive.google.com/file/d/1nBJCqCmlDQC5kISRHAJWv0yMRgfoSBkD/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Selina22",
  linkedin: "https://www.linkedin.com/in/selinawan",
  gmail: "selwan@seas.upenn.edu",
  googleScholar: "https://scholar.google.com/citations?user=PWbtRvgAAAAJ&hl=en",
  //gitlab: "https://gitlab.com/saadpasta",
  //facebook: "https://www.facebook.com/saad.pasta7",
  //medium: "https://medium.com/@saadpasta",
  //stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "University of Pennsylvania",
      logo: require("./assets/images/upenn.png"),
      subHeader: "Master of Science in Engineering in Robotics",
      duration: "September 2024 - June 2026",
      desc: "GRASP Laboratory, Co-supervised by Prof. Dinesh Jayaraman & Prof. Pratik Chaudhari",
      descBullets: [
        "Courses taken: Principles of Deep Learning, Computer Vision, Graphical Neural Networks",
        "TA: Computer Vision (Fall 2025)",
        "Instructor at Fife-Penn STEM & CS Academy (Fall 2024 & Spring 2025)"
      ]
    },
    {
      schoolName: "University of Toronto",
      logo: require("./assets/images/uoft.png"),
      subHeader: "Bachelor of Science in Engineering Science",
      duration: "September 2018 - June 2024",
      desc: "Robotics Major, Machine Intelligence Minor",
      descBullets: [
        "Dean's List (2020, 2023), Dean's Merit Award (2018)",
        "Engigineering Science Ambassador, UT Robotics Association Member and Project Manager, Self-Driving Car Sub-team Lead",
        "Took two gap years (2021-2022) for work and research experiences and avoid the pandemic online school time",
        "Some courses taken: Learning in Robotics, Control, Artificial Intelligence, Software Design, Database"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Machine Learning Intern",
      company: "Universal Studios",
      companylogo: require("./assets/images/ubr-logo.png"),
      date: "May 2023 – Aug 2023",
      desc: "Strategic and Data Service Team, Revenue Management.",
      descBullets: [
        "Performed various feature engineering techniques such as feature selection and missing data imputation on park attendance data",
        "Developed Seasonal ARIMA and Prophet models in Python for park attendance and call center forecast, improved the existing forecast accuracy by at least 10%",
        "Conducted weekly business reporting, including ticket sales and admission analysis, ticket pricing parity/integrity report, and competitive hotels pricing monitoring"
      ]
    },
    {
      role: "Software Engineering Intern",
      company: "General Motors",
      companylogo: require("./assets/images/gm.png"),
      date: "Sep 2021 – Dec 2021",
      desc: "Automated Driving and Active Safety, Map Data Tools Core Team",
      descBullets: [
        "Developed map data tools backend functionalities for Super Cruise in C#, such as tools-specific exception handler",
        "Developed frontend features in JavaScript to improve user interactivity with the map",
        "Delivered bi-weekly demonstrations to the team of the developed features"
      ]
    },
    {
      role: "Software Engineering Student Researcher",
      company: "Huawei Technologies Canada",
      companylogo: require("./assets/images/huawei.jpg"),
      date: "Jan 2021 – Sep 2021",
      desc: "2012 Laboratories, Centre of Software Excellence",
      descBullets: [
        "Conducted research on open-source machine learning frameworks (e.g., PyTorch, TensorFlow, scikit-learn)",
        "Collected academic related ML GitHub repositories from Papers With Code dataset using MySQL",
        "Statically analyzed source codes from over 30,000 open-source repositories of academic publications for feature adoptions using Python"
      ]
    }
  ]
};

const researchExperiences = {
  title: "Research Experience",
  // subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      images: [require("./assets/images/maestro_method.png"), require("./assets/images/trash.mp4"), require("./assets/images/cut_banana_with_knife.mp4")],
      projectName: "Graduate Student Researcher | UPenn PAL Group",
      projectDesc: "Maestro: Orchestrating Robotics Modules with Vision-Language Models for Zero-Shot Generalist Robots",
      descBullets: [
        "Maestro is a novel VLM-based coding agent that generates programmatic robotics policies by composing modular tools (perception, geometry, control, image editing, w/ or w/o VLA). It creates generalist policies for both table-top and mobile manipulators, offering zero-shot capability and support for active perception. Maestro's strong zero-shot performance enables automated data collection and outperforms VLA-only systems in certain real-world applications.",
        "ICRA, 2026 (Under Review)", "CoRL RoboArena Workshop, 2025 (Oral)", "NeurIPS SpaVLE workshop, 2025 (Oral)"
      ],
      footerLink: [
        {
          name: "Project Page",
          url: "https://maestro-robot.github.io/"
        },
        {
          name: "Unitree Agent SDK",
          url: "https://github.com/grasp-lyrl/unitree_go2w_agent_sdk"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/sperm.png"),
      projectName: "Undergraduate Thesis Researcher | Advanced Micro and Nanosystems Laboratory",
      projectDesc: "I completed my undergraduate thesis project, supervised by Professor Yu Sun at the University of Toronto.",
      descBullets: [
        "Objective: use a multi-object tracking (MOT) method to determine the morphology and motility of sperms",
        "Created the MOT system utilizing the YOLOX detector and a Kalman filter-based tracking algorithm to integrate and associate all bounding boxes for accurate data tracking",
        "Evaluated on a manually labeled microscopic-level dataset, achieving 80% tracking accuracy over the time span",
        "The final project is under submission to ICRA 2025"
      ],
      footerLink: [
        {
          name: "View Report",
          url: "https://drive.google.com/file/d/1-JkIB5cAiRk3pJVyaMYepN5CpSCQ8yQQ/view?usp=sharing"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/kitti.jpg"),
      projectName: "Visiting Researcher | Robotics and Computer Vision Lab",
      projectDesc: "Research topic: Visual SLAM, Supervised by Professor Hong Zhang",
      descBullets: [
        "Designed a keyframe selection method with a convolutional neural network for direct method visual simultaneous localization and mapping (VSLAM) systems",
        "Implemented the design on LDSO (direct sparse odometry with loop closure) with a pre-trained FlowNetSimple model in C++. The final work is accepted and presented at IEEE ROBIO 2022",
        "Developed a SLAM Performance Predictor using customized characterization metrics and recurrent neural network autoencoder"
      ],
      footerLink: [
        {
          name: "View VSLAM Paper",
          url: "https://ieeexplore.ieee.org/abstract/document/10011968"
        },
        {
          name: "View Predictor Slides",
          url: "https://drive.google.com/file/d/1YAUuaT66LW9Gk8sIeclOuq-1oRQVIb57/view?usp=sharing"
        }
      ]
    },
    {
      image: require("./assets/images/autoronto.jpg"),
      projectName: "Mapping and Localization Team Lead | aUToronto",
      projectDesc: "aUToronto is the self-driving car team at the University of Toronto, supervised by Profs. Timothy Barfoot & Steven Waslander",
      descBullets: [
        "Managed a team of eight to develop maps and localization method to participate in the SAE AutoDrive Challenge",
        "Developed the semantic localization system using nearest neighbour, ICP, Cauchy M-estimation, and IEKF",
        "Designed a custom internal map data structure in Python to model road networks and assign semantic labels",
        "Implemented map data tools such as the curvature smoother to automate the mapping pipeline"
      ],
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.autodrive.utoronto.ca/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/main_headline.jpg"),
      projectName: "Undergraduate Researcher | Intelligent Sensory Microsystems Lab",
      projectDesc: "A summer research supervised by Professor Roman Genov.",
      descBullets: [
        "Developed GUI in Python for 5 camera sensors and used Opal Kelly board to communicate between FPGA and API",
        "Designed and implemented new functionalities such as white balancing on GUI to simplify canera sensors testing processing"
      ]
    },
    {
      image: require("./assets/images/xbot.jpg"),
      projectName: "Research Assistant | Institute of Software, Chinese Academy of Sciences",
      //projectDesc: "aUToronto is the self-driving car team at the University of Toronto, supervised by Profs. Timothy Barfoot & Steven Waslander",
      descBullets: [
        "Programmed XBot (an educational robot) using Python and C++ to guide a tour for 50 students around a museum",
        "Assisted in designing SLAM courses for middle school students by self-learning ROS and literature",
        "Developed lab activities with 2 others using Gazebo simulator by writing code solutions and testing on the XBot",
      ],
      footerLink: [
        {
          name: "Visit Website",
          url: "https://wiki.ros.org/cn/Robots/Xbot"
        }
        //  you can add extra buttons here.
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Other Selected Project",
  //subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      video: require("./assets/images/rob.MOV"),
      projectName: "Robot Planning and Navigation",
      projectDesc: "Implemented RRT* to plan efficient and collision-free paths to the goal state. Obstacle avoidance was achieved by validating sampled paths during trajectory simulation. The algorithm utilized a proportional controller for linear and angular velocity and integrated trajectory rollout for local path planning to ensure accurate and adaptable navigation in dynamic environments.",
    },
    {
      video: require("./assets/images/IMG_5022.mov"),
      projectName: "Raspberry Pi Dog",
      projectDesc: "Designed and built a cost-effective quadruped robot using 3D-printed parts, servo motors, IMU sensor, and a Raspberry Pi 4B microcontroller. The robot dog could perform smooth walking motion and self-balancing functionalities through Python-based control algorithms. This video here shows the dog doing push-ups",
    },
    {
      video: require("./assets/images/drone.MOV"),
      projectName: "Flying Drone",
      projectDesc: "Designed and implemented an autonomous UAV capable of stable hovering, waypoint navigation, and obstacle avoidance. Utilizing advanced hardware like the Pixhawk 4, Jetson Nano, and Intel RealSense T265, along with custom algorithms",
    },
    {
      image: require("./assets/images/ai-eye.png"),
      projectName: "Household Item Recognition System for Visually Impaired Individuals",
      projectDesc: " Built and trained a neural network model, using PyTorch, that can locate object with a pre-trained Detectron 2 model and classify household items for the visually impaired. Implemented capsule layers on a convolutional neural network to improve the model accuracy by 19.14%",
      footerLink: [
        {
          name: "Visit GitHub",
          url: "https://github.com/Selina22/Household-Item-Recognition-System"
        }
      ]
    },
    {
      image: require("./assets/images/software-design.png"),
      projectName: "Java Trading System",
      projectDesc: "Designed and developed a trading system program in Java with a team of six. Encapsulated different parts of the program well by implementing several design patterns such as factory method and singleton, and closely followed the clean architecture and SOLID principles",
      footerLink: [
        {
          name: "View Presentation",
          url: "https://youtu.be/KbRlJZzOzGw"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  email_address: "selwan at seas dot upenn dot edu"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  researchExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
